import EmptyComponent from './EmptyComponent.vue'

export const emptyRoutes = {
  path: '/empty',
  name: 'Empty',
  component: EmptyComponent,
  meta: {
    title: 'Empty page',
    requireAuth: false,
  }
};
